import english from '../en/cinema';

export default {
  ...english,
  cinema_referral: "Kiếm tiền bằng cách chia sẻ",
  cinema_referralDesc: "Mời bạn bè qua liên kết cá nhân của bạn và nhận thưởng",
  cinema_referralLinkTitle: "Liên kết giới thiệu của tôi",
  cinema_referralLinkDesc: "Các đăng ký mới qua liên kết này sẽ được tính cho bạn",
  cinema_referralRulesTitle: "Quy định về giới thiệu",
  cinema_referralRulesCoins: "Khi một người bạn đăng ký thông qua liên kết giới thiệu của bạn, bạn có thể nhận được phần thưởng bằng xu. Xu chỉ dùng để xem nội dung trên nền tảng và không thể quy đổi thành tiền mặt hoặc rút ra.",
  cinema_referralRulesCommission: "Khi một người bạn nạp tiền, bạn có thể nhận được hoa hồng theo các quy định áp dụng. Chỉ hoa hồng từ nạp tiền là có thể rút; khi đạt 100 nhân dân tệ, bạn có thể yêu cầu rút USDT.",
  cinema_copyLink: "Sao chép liên kết",
  cinema_inviteCodeLabel: "Mã giới thiệu",
  cinema_inviteRuleTitle: "Phần thưởng giới thiệu",
  cinema_inviteRuleNormal: "Thành viên nhận 20 xu cho mỗi lần đăng ký thành công. Phần thưởng được ghi lại trong lịch sử xu.",
  cinema_distributorOverview: "Tổng quan về nhà phân phối",
  cinema_availableCommission: "Đang có sẵn",
  cinema_totalCommission: "Tổng hoa hồng",
  cinema_pendingWithdrawal: "Đang chờ rút",
  cinema_withdrawnAmount: "Đã rút",
  cinema_firstLevelRate: "Tỷ lệ cấp 1",
  cinema_secondLevelRate: "Tỷ lệ cấp 2",
  cinema_todayBrowse: "Lượt xem",
  cinema_todayRegister: "Số lượng đăng ký",
  cinema_todayRecharge: "Số lượng nạp tiền",
  cinema_todayRechargeAmount: "Số tiền nạp",
  cinema_commissionAmount: "Hoa hồng",
  cinema_registerDetails: "Số lượng đăng ký",
  cinema_rechargeDetails: "Số lượng nạp tiền",
  cinema_inviteRewards: "Phần thưởng giới thiệu",
  cinema_goWithdraw: "Rút",
  cinema_noReferralData: "Chưa có dữ liệu giới thiệu",
  cinema_referralLoadFailed: "Không thể tải dữ liệu giới thiệu. Vui lòng thử lại.",
  cinema_loginToPromote: "Đăng nhập để tạo liên kết giới thiệu của bạn",
  cinema_totalEarnings: "Tổng thu nhập",
  cinema_withdrawable: "Có thể rút",
  cinema_frozen: "Bị đóng băng",
  cinema_invitedCount: "Đã mời",
  cinema_coinUnit: "xu",
  cinema_people: "người",
  cinema_conversionStats: "Tỷ lệ chuyển đổi giới thiệu",
  cinema_allDatesTotal: "Tổng tất cả các ngày",
  cinema_selectedDatesTotal: "Tổng ngày đã chọn",
  cinema_conversionStatsDesc: "Lượt xem, số lượng đăng ký, số lượng nạp tiền và hoa hồng theo ngày",
  cinema_colDate: "Ngày",
  cinema_colPv: "Người truy cập",
  cinema_colBrowseCount: "Lượt xem",
  cinema_colRegister: "Số lượng đăng ký",
  cinema_colRechargeUsers: "Người thanh toán",
  cinema_colRechargeOrders: "Đơn hàng",
  cinema_colPaidAmount: "Số tiền đã thanh toán",
  cinema_colCommission: "Hoa hồng",
  cinema_colRegisterRate: "Tỷ lệ đăng ký",
  cinema_colRechargeRate: "Tỷ lệ nạp tiền",
  cinema_commissionRateTitle: "Tỷ lệ hoa hồng",
  cinema_currentRateLabel: "Tỷ lệ hoa hồng thực tế hiện tại",
  cinema_baseRate: "Tỷ lệ cơ bản",
  cinema_currentRate: "Tỷ lệ hiện tại",
  cinema_earningsRecord: "Hồ sơ thu nhập",
  cinema_inviteDetail: "Chi tiết mời",
  cinema_allEarnings: "Tất cả thu nhập",
  cinema_filterAll: "Tất cả",
  cinema_filterPending: "Đang chờ xử lý",
  cinema_filterSettled: "Đã giải quyết",
  cinema_earningsDate: "Ngày",
  cinema_earningsType: "Loại",
  cinema_earningsUser: "Người dùng",
  cinema_earningsAmount: "Thu nhập",
  cinema_earningsStatus: "Trạng thái",
  cinema_statusSettled: "Đã giải quyết",
  cinema_statusPending: "Đang chờ xử lý",
  cinema_noEarningsRecords: "Chưa có hồ sơ nào",
  cinema_referralUser: "Người dùng",
  cinema_referralRegDate: "Đã đăng ký",
  cinema_referralRecharged: "Tổng số tiền nạp",
  cinema_referralEarned: "Thu nhập của tôi",
  cinema_startDate: "Ngày bắt đầu",
  cinema_endDate: "Ngày kết thúc",
  cinema_query: "Tìm kiếm",
  cinema_dateRangeError: "Ngày bắt đầu không được sau ngày kết thúc",
  cinema_brand: "Huangguo TV",
  cinema_language: "Ngôn ngữ",
  cinema_tagline: "Phim ngắn AI nguyên bản",
  cinema_navHome: "Trang chủ",
  cinema_navCategories: "Xếp hạng",
  cinema_rankingTitle: "Xếp hạng",
  cinema_rankingAll: "Tất cả",
  cinema_rankingLoading: "Đang tải xếp hạng...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} loạt phim · {{views}} lượt xem",
  cinema_rankingTotal: "Suốt thời gian",
  cinema_rankingMonth: "Hàng tháng",
  cinema_rankingWeek: "Hàng tuần",
  cinema_rankingLatest: "Mới nhất",
  cinema_rankingCreator: "Nhà sáng tạo",
  cinema_creatorLabel: "Nhà sáng tạo",
  cinema_rankingEmpty: "Chưa có loạt phim nào được xếp hạng",
  cinema_navMyList: "Thịnh hành",
  cinema_soundGuideTitle: "Nhấn vào đây để bật âm thanh",
  cinema_soundGuideAction: "Bật âm thanh",
  cinema_soundGuideDismiss: "Tắt hướng dẫn âm thanh",
  cinema_navHistory: "Lịch sử",
  cinema_navAds: "Kiếm xu",
  cinema_adsTitle: "Quảng cáo nổi bật",
  cinema_adsSubtitle: "Khám phá thêm nội dung nổi bật",
  cinema_adFeatured: "Nổi bật",
  cinema_adOpen: "Xem ngay",
  cinema_adsEmpty: "Không có quảng cáo nào available",
  cinema_adsLoadFailed: "Không thể tải quảng cáo. Vui lòng thử lại.",
  cinema_earnTitle: "Kiếm xu",
  cinema_earnSubtitle: "Đăng nhập hàng ngày và nhận xu",
  cinema_earnBalance: "Xu của tôi",
  cinema_checkInTitle: "Đăng nhập hàng ngày",
  cinema_checkInSubtitle: "Duy trì chuỗi đăng nhập để kiếm thêm xu",
  cinema_checkInDay: "Ngày {{day}}",
  cinema_checkInToday: "Hôm nay",
  cinema_checkInClaim: "Đăng nhập để nhận {{points}} xu",
  cinema_checkInClaimed: "Đã đăng nhập hôm nay",
  cinema_checkInLogin: "Đăng nhập để đăng nhập",
  cinema_checkInSuccess: "Đăng nhập hoàn tất. Bạn đã kiếm được {{points}} xu",
  cinema_checkInFailed: "Đăng nhập thất bại. Vui lòng kiểm tra kết nối và thử lại",
  cinema_checkInNoReward: "Thiết bị này đã nhận phần thưởng đăng nhập hôm nay",
  cinema_checkInStreak: "Chuỗi hiện tại",
  cinema_checkInStreakValue: "{{days}} ngày",
  cinema_checkInTotal: "Tổng số đã kiếm được",
  cinema_checkInTotalValue: "{{points}} xu",
  cinema_checkInLoadFailed: "Không tải được trạng thái điểm danh",
  cinema_retry: "Hãy thử lại",
  cinema_moreEarnWays: "Thêm cách để kiếm",
  cinema_inviteEarnTitle: "Mời bạn bè và kiếm",
  cinema_inviteEarnDesc: "Kiếm xu khi bạn bè đăng ký",
  cinema_goInvite: "Mời",
  cinema_earnCoinsTitle: "Kiếm Xu",
  cinema_earnCoinsBalance: "Xu của tôi",
  cinema_earnCoinsSignInStreak: "Bạn đã điểm danh trong {{count}} ngày",
  cinema_earnCoinsCheckIn: "Điểm Danh",
  cinema_earnCoinsCheckedIn: "Đã Điểm Danh",
  cinema_earnCoinsTomorrow: "Quay lại vào ngày mai",
  cinema_earnCoinsInviteTitle: "Mời bạn bè để kiếm",
  cinema_earnCoinsInviteCode: "Mã mời của tôi",
  cinema_earnCoinsGoInvite: "Mời ngay",
  cinema_earnCoinsLimitedTask: "Nhiệm vụ giới hạn",
  cinema_earnCoinsTimeLeft: "Đếm ngược",
  cinema_earnCoinsNewbieTask: "Nhiệm vụ cho người mới",
  cinema_earnCoinsDailyTask: "Nhiệm vụ hàng ngày",
  cinema_earnCoinsRecommendations: "Được đề xuất",
  cinema_earnCoinsAdTask: "Xem quảng cáo",
  cinema_earnCoinsAdTaskDesc: "Xem quảng cáo để kiếm thêm xu",
  cinema_earnCoinsGoWatch: "Xem Quảng Cáo",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "Ngày {{day}}",
  cinema_earnCoinsToday: "Hôm nay",
  cinema_earnCoinsCoinUnit: "xu",
  cinema_earnCoinsAdCurrent: "Nhiệm vụ hiện tại",
  cinema_earnCoinsAdLocked: "Nhiệm vụ bị khóa",
  cinema_earnCoinsTaskCompleted: "Đã hoàn thành",
  cinema_limitedRechargeTaskTitle: "Hoàn thành lần nạp đầu tiên trong vòng 1 giờ",
  cinema_limitedRechargeTaskAction: "Nạp Tiền",
  cinema_claimReward: "Nhận",
  cinema_claiming: "Đang nhận",
  cinema_taskClaimFailed: "Nhận thất bại. Vui lòng thử lại.",
  cinema_bindEmailAction: "Liên kết Email",
  cinema_limitedRechargeTaskExpired: "Hết hạn",
  cinema_watchHistory: "Lịch sử xem",
  cinema_navSearch: "Tìm kiếm series...",
  cinema_login: "Đăng nhập",
  cinema_vip: "Nạp tiền",
  cinema_heroPlay: "Phát ngay",
  cinema_heroMore: "Tìm hiểu thêm",
  cinema_hotRecommend: "Đang thịnh hành",
  cinema_carouselLoading: "Đang tải nội dung nổi bật...",
  cinema_newRelease: "Bản phát hành mới",
  cinema_allSeries: "Tất cả series",
  cinema_viewAll: "Xem tất cả",
  cinema_episodes: "{{count}} tập",
  cinema_rating: "Xếp hạng {{score}}",
  cinema_views: "{{count}} lượt xem",
  cinema_play: "Phát",
  cinema_continueWatch: "Tiếp tục xem",
  cinema_rewatch: "Xem lại",
  cinema_categoryAll: "Tất cả",
  cinema_categoryUrban: "Tình cảm đô thị",
  cinema_categorySuspense: "Kịch tính",
  cinema_categoryCostume: "Lịch sử",
  cinema_categoryWorkplace: "Công sở",
  cinema_categorySciFi: "Khoa học viễn tưởng",
  cinema_categorySciFiRomance: "Tình cảm khoa học viễn tưởng",
  cinema_unlock: "Mở khóa tập",
  cinema_unlockDesc: "Mở khóa tập này tốn {{cost}} xu",
  cinema_unlockConfirm: "Xác nhận & Phát",
  cinema_cancel: "Hủy",
  cinema_balance: "Số dư: {{coins}} xu",
  cinema_insufficient: "Không đủ xu, vui lòng nạp tiền",
  cinema_unlocked: "Đã mở khóa",
  cinema_locked: "Đã khóa",
  cinema_episodeNumber: "Tập {{number}}",
  cinema_playing: "Đang phát",
  cinema_backToList: "Quay lại danh sách",
  cinema_back: "Quay lại",
  cinema_noSeries: "Không có series nào available",
  cinema_seriesDesc: "Nội dung tóm tắt",
  cinema_episodeList: "Các tập",
  cinema_nextEpisode: "Tiếp theo",
  cinema_episodeEnded: "Tập đã kết thúc",
  cinema_nextEpisodePrompt: "Có tiếp tục với tập {{number}} không?",
  cinema_playNextEpisode: "Phát tập tiếp theo",
  cinema_prevEpisode: "Trước đó",
  cinema_freeLabel: "Miễn phí",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "Mới",
  cinema_hotLabel: "Hot",
  cinema_featuredBanner: "Phải xem tuần này",
  cinema_watchNow: "Xem ngay",
  cinema_searchPlaceholder: "Tìm phim",
  cinema_noResults: "Không tìm thấy series nào",
  cinema_emptyMyList: "Chưa có series nào trong danh sách của bạn",
  cinema_emptyHistory: "Chưa có lịch sử xem",
  cinema_addToMyList: "Thêm vào Danh sách của tôi",
  cinema_removeFromMyList: "Xóa khỏi Danh sách của tôi",
  cinema_clearAll: "Xóa tất cả",
  cinema_footerCopy: "Huangguo TV — Nền tảng phim ngắn cao cấp",
  cinema_footerWarning: "Nội dung được tạo bởi AI nhằm mục đích giải trí. Vui lòng tuân thủ pháp luật địa phương.",
  cinema_myList: "Danh sách của tôi",
  cinema_addedAt: "Đã thêm {{date}}",
  cinema_expand: "Mở rộng",
  cinema_collapse: "Thu gọn",
  cinema_historyAll: "Tất cả",
  cinema_historyUnfinished: "Chưa hoàn thành",
  cinema_historyFinished: "Đã hoàn thành",
  cinema_historyCount: "{{count}} bản ghi",
  cinema_noHistoryFilter: "Không có bản ghi nào trong danh mục này",
  cinema_finished: "Đã hoàn thành",
  cinema_watchedFull: "Đã hoàn tất",
  cinema_welcomeBack: "Chào mừng trở lại",
  cinema_loginDesc: "Đăng nhập để mở khóa thêm nội dung",
  cinema_phoneLogin: "Đăng nhập bằng số điện thoại",
  cinema_emailLogin: "Đăng nhập bằng email",
  cinema_phonePlaceholder: "Nhập số điện thoại",
  cinema_emailPlaceholder: "Nhập địa chỉ email",
  cinema_agreeTerms: "Khi đăng nhập, bạn đồng ý với",
  cinema_userAgreement: "Thỏa thuận người dùng",
  cinema_privacyPolicy: "Chính sách quyền riêng tư",
  cinema_getCode: "Lấy mã",
  cinema_loginNow: "Đăng nhập ngay",
  cinema_otherLogin: "Các phương thức đăng nhập khác",
  cinema_loggingIn: "Đang đăng nhập...",
  cinema_loginSuccess: "Đăng nhập thành công",
  cinema_loginRedirect: "Đang chuyển hướng đến trang cá nhân...",
  cinema_profile: "Trang cá nhân",
  cinema_memberLabel: "Thành viên",
  cinema_dealerLabel: "Nhà phân phối",
  cinema_coinAmount: "{{count}} xu",
  cinema_profileAccount: "Tài khoản",
  cinema_profileContent: "Nội dung",
  cinema_profileSettings: "Cài đặt",
  cinema_editProfile: "Chỉnh sửa trang cá nhân",
  cinema_myCoins: "Xu của tôi",
  cinema_myPurchases: "Đã mua",
  cinema_downloads: "Tải xuống",
  cinema_playbackSettings: "Cài đặt phát lại",
  cinema_notifications: "Thông báo",
  cinema_cacheManage: "Quản lý bộ nhớ đệm",
  cinema_about: "Liên hệ với chúng tôi",
  cinema_contactUnavailable: "Dịch vụ khách hàng hiện không khả dụng. Vui lòng thử lại sau.",
  cinema_watchedHours: "Số giờ xem",
  cinema_collectionCount: "Bộ sưu tập",
  cinema_logout: "Đăng xuất",
  cinema_logoutConfirm: "Xác nhận đăng xuất?",
  cinema_logoutConfirmDesc: "Bạn sẽ cần đăng nhập lại để sử dụng đầy đủ các tính năng",
  cinema_version: "Phiên bản {{version}}",
  cinema_rechargeTitle: "Nạp tiền",
  cinema_rechargeSubtitle: "Chọn gói nạp tiền",
  cinema_rechargeVpnWarning: "VPN hoặc proxy có thể kích hoạt các biện pháp kiểm soát rủi ro thanh toán, khiến quá trình thanh toán không mở được hoặc dẫn đến thất bại trong thanh toán.",
  cinema_rechargeVpnGuideTitle: "Vui lòng tắt VPN trước khi thanh toán",
  cinema_rechargeVpnInstruction: "Sau khi tắt VPN, hãy nhấp vào nút bên dưới để tiếp tục với phương thức thanh toán đã chọn.",
  cinema_rechargeVpnContinue: "VPN đã tắt, tiếp tục thanh toán",
  cinema_rechargeRMB: "Nạp RMB",
  cinema_rechargeUSDT: "Nạp USDT",
  cinema_rechargeRecommended: "Được đề xuất",
  cinema_rechargeCoins: "Xu",
  cinema_rechargeBonus: "Thưởng +{{points}}",
  cinema_rechargeCredited: "Nhận {{points}}",
  cinema_firstRechargeBannerTitle: "Thưởng nạp lần đầu! Phần thưởng thêm cho mọi số tiền nạp",
  cinema_firstRechargeSelectedBonus: "+{{points}} xu",
  cinema_firstRechargeLimitedTitle: "Thưởng nạp lần đầu giới hạn",
  cinema_dailyRechargeLimitedTitle: "Thưởng nạp giới hạn",
  cinema_firstRechargeLimitedBonus: "Thêm {{percent}}% cho mọi số tiền nạp",
  cinema_rechargePayMethod: "Phương thức thanh toán",
  cinema_rechargePay: "Thanh toán",
  cinema_rechargeNoPackages: "Hiện tại không có gói nạp tiền nào khả dụng",
  cinema_paymentUnavailable: "Hiện tại thanh toán chưa khả dụng. Vui lòng liên hệ bộ phận hỗ trợ.",
  cinema_follow: "Theo dõi",
  cinema_collect: "Thu thập",
  cinema_share: "Chia sẻ",
  cinema_loading: "Đang tải...",
  cinema_favorites: "Yêu thích",
  cinema_emptyFavorites: "Chưa có series yêu thích nào",
  cinema_emptyPurchases: "Chưa có series nào được mua",
  cinema_clearAllConfirm: "Xóa toàn bộ lịch sử xem?",
  cinema_episodesUnit: "Tập phim",
  cinema_lastWatched: "Tập phim cuối cùng đã xem {{episode}}",
  cinema_purchasedEpisodes: "Đã mở khóa {{count}} tập phim",
  cinema_account: "Tài khoản",
  cinema_accountName: "Tên hiển thị",
  cinema_accountEmail: "Email",
  cinema_shareCode: "Chia sẻ mã",
  cinema_saveProfile: "Lưu hồ sơ",
  cinema_profileSaved: "Hồ sơ đã được lưu",
  cinema_profileSaveFailed: "Không thể lưu hồ sơ",
  cinema_accountInfo: "Thông tin cơ bản",
  cinema_changePassword: "Đổi mật khẩu",
  cinema_newPassword: "Mật khẩu mới",
  cinema_confirmPassword: "Xác nhận mật khẩu mới",
  cinema_passwordHint: "Sử dụng ít nhất 6 ký tự",
  cinema_passwordMismatch: "Hai mật khẩu không khớp",
  cinema_passwordSaved: "Mật khẩu đã được cập nhật",
  cinema_passwordSaveFailed: "Cập nhật mật khẩu thất bại",
  cinema_savePassword: "Lưu mật khẩu",
  cinema_pointsBalance: "Số dư xu",
  cinema_coinLedger: "Sổ ghi chép xu",
  cinema_businessReference: "Tham khảo",
  cinema_emptyPointLogs: "Chưa có lịch sử xu",
  cinema_pointLog_registerReward: "Phần thưởng đăng ký",
  cinema_pointLog_appFirstLoginReward: "Phần thưởng đăng nhập lần đầu vào ứng dụng",
  cinema_pointLog_inviteReward: "Phần thưởng mời bạn",
  cinema_pointLog_dailyCheckIn: "Phần thưởng điểm danh hàng ngày",
  cinema_pointLog_limitedRechargeTask: "Phần thưởng nhiệm vụ nạp tiền lần đầu giới hạn",
  cinema_pointLog_emailBindingTask: "Phần thưởng nhiệm vụ liên kết email",
  cinema_pointLog_dailyUnlockTask: "Phần thưởng nhiệm vụ mở khóa tập phim hàng ngày",
  cinema_bindEmailTaskTitle: "Liên kết email",
  cinema_dailyUnlockTaskTitle: "Mở khóa {{count}} tập mới",
  cinema_unlockAction: "Mở khóa",
  cinema_dailyTaskProgress: "Tiến độ hôm nay {{current}}/{{target}} (không tính tập 1)",
  cinema_pointLog_firstEpisodeUnlock: "Mở khóa tập đầu tiên",
  cinema_pointLog_episodeUnlock: "Mở khóa tập",
  cinema_pointLog_recharge: "Nạp tiền đã được ghi có",
  cinema_pointLog_firstRechargeBonus: "Thưởng nạp lần đầu",
  cinema_pointLog_dailyRechargeBonus: "Thưởng nạp giới hạn",
  cinema_pointLog_adminAdjust: "Điều chỉnh của quản trị viên",
  cinema_pointLog_other: "Thay đổi xu",
  cinema_pointBiz_register: "Đăng ký",
  cinema_pointBiz_registerBackfill: "Bù thưởng đăng ký",
  cinema_pointBiz_appFirstLogin: "Đăng nhập ứng dụng lần đầu",
  cinema_pointBiz_inviteRegister: "Đăng ký qua lời mời",
  cinema_pointBiz_dailyCheckIn: "Điểm danh hàng ngày",
  cinema_pointBiz_legacyLimitedRechargeTask: "Nhiệm vụ nạp tiền 24 giờ",
  cinema_pointBiz_limitedRechargeTask: "Nhiệm vụ nạp tiền đầu tiên trong 1 giờ",
  cinema_pointBiz_emailBindingTask: "Nhiệm vụ liên kết email",
  cinema_pointBiz_unlockThreeEpisodes: "Nhiệm vụ mở khóa 3 tập mỗi ngày",
  cinema_pointBiz_unlockFiveEpisodes: "Nhiệm vụ mở khóa 5 tập mỗi ngày",
  cinema_pointBiz_episodeUnlock: "Mở khóa tập",
  cinema_pointBiz_rechargeOrder: "Đơn nạp tiền",
  cinema_pointBiz_adminAdjust: "Điều chỉnh của quản trị viên",
  cinema_pointBiz_other: "Hoạt động khác",
  cinema_playbackAutoplay: "Tự động phát tập tiếp theo",
  cinema_playbackAutoplayDesc: "Tự động tiếp tục khi một tập kết thúc",
  cinema_aboutDesc: "My Fantasy mang đến cho bạn nội dung phim ngắn được cập nhật liên tục.",
  cinema_rechargeOrders: "Sổ nạp tiền",
  cinema_myRechargeRecords: "Xem lịch sử nạp tiền của tôi",
  cinema_totalInvites: "Tổng số lời mời",
  cinema_distributionStats: "Thống kê khuyến mãi",
  cinema_distributionStatsDesc: "Xem lượt truy cập, đăng ký, nạp tiền và hoa hồng theo ngày",
  cinema_summaryDate: "Ngày",
  cinema_summaryBrowse: "Lượt xem",
  cinema_summaryRegister: "Số lượng đăng ký",
  cinema_summaryRechargeCount: "Số lượng nạp tiền",
  cinema_conversionRate: "Tỷ lệ chuyển đổi",
  cinema_commissionRatio: "Tỷ lệ hoa hồng",
  cinema_browseDetails: "Xem chi tiết",
  cinema_browseTime: "Thời gian xem",
  cinema_browseDrama: "Phim",
  cinema_browseRegion: "Khu vực",
  cinema_noBrowseData: "Chưa có dữ liệu lượt xem",
  cinema_noSummaryData: "Chưa có dữ liệu tóm tắt",
  cinema_rewarded: "Đã thưởng",
  cinema_registered: "Đã đăng ký",
  cinema_close: "Đóng",
  cinema_emptyRechargeOrders: "Chưa có lịch sử nạp tiền",
  cinema_rechargeRecords: "Sổ ghi nợ nạp tiền",
  cinema_commissionRecords: "Sổ ghi nợ hoa hồng",
  cinema_rechargeTime: "Thời gian nạp tiền",
  cinema_paymentMethod: "Phương thức thanh toán",
  cinema_paymentStatus: "Trạng thái thanh toán",
  cinema_orderNo: "Mã đơn hàng",
  cinema_noRechargeRecords: "Chưa có lịch sử nạp tiền",
  cinema_commissionTime: "Thời gian nhận hoa hồng",
  cinema_commissionLevel: "Cấp độ hoa hồng",
  cinema_commissionRate: "Tỷ lệ hoa hồng",
  cinema_noCommissionRecords: "Chưa có lịch sử hoa hồng",
  cinema_search: "Tìm kiếm",
  cinema_reset: "Đặt lại",
  cinema_previousPage: "Trước đó",
  cinema_nextPage: "Tiếp theo",
  cinema_paymentStatus_created: "Đã tạo",
  cinema_paymentStatus_pending: "Đang chờ thanh toán",
  cinema_paymentStatus_paid: "Nạp tiền hoàn tất",
  cinema_paymentStatus_failed: "Thanh toán thất bại",
  cinema_paymentStatus_closed: "Đã đóng",
  cinema_paymentStatus_expired: "Hết hạn",
  cinema_paymentAwaiting: "Đơn hàng đã được tạo. Vui lòng hoàn tất thanh toán trên trang thanh toán. Nếu thanh toán thất bại, vui lòng kiểm tra xem VPN của bạn đã được tắt chưa.",
  cinema_usdtAddress: "Địa chỉ nhận",
  cinema_usdtNetwork: "Chỉ hỗ trợ mạng TRC20",
  cinema_copy: "Sao chép",
  cinema_copied: "Đã sao chép",
  cinema_playerSettings: "Cài đặt phát lại",
  cinema_playerQuality: "Chất lượng",
  cinema_playerSpeed: "Tốc độ phát lại",
  cinema_playerAuto: "Tự động",
  cinema_playerSource: "Bản gốc",
  cinema_playerSubtitles: "Phụ đề",
  cinema_subtitleAuto: "Tự động",
  cinema_subtitleOff: "Tắt phụ đề",
  cinema_appDownloadTitle: "Xem tập tiếp theo một cách ổn định hơn trên Ứng dụng",
  cinema_appDownloadDesc: "Ghi nhớ tiến trình của bạn và nhận thông báo về các cập nhật.",
  cinema_appDownloadReward: "Tải ứng dụng và nhận {{points}} xu thưởng ngay lần đăng nhập đầu tiên!",
  cinema_homeAppDownloadReward: "Nhận {{points}} xu thưởng khi bạn đăng nhập bằng ứng dụng!",
  cinema_shareEarnPoints: "Chia sẻ & Kiếm tiền",
  cinema_shareLinkLabel: "Chia sẻ liên kết",
  cinema_shareRewardUnlimited: "Kiếm {{points}} xu cho mỗi người dùng mới tham gia qua liên kết của bạn, không giới hạn số lượng!",
  cinema_loginForShareLink: "Đăng nhập để lấy liên kết chia sẻ của bạn",
  cinema_viewReferralStats: "Xem thống kê giới thiệu",
  cinema_episodeFinished: "Tập đã hoàn thành",
  cinema_unlockNextEpisode: "Mở khóa tập tiếp theo",
  cinema_changeDrama: "Thay đổi video",
  cinema_allUnlocked: "Đã mở khóa tất cả",
  cinema_appDownloadButton: "Tải ứng dụng",
  cinema_appDownloadUnavailable: "Hiện tại chưa hỗ trợ tải xuống",
  cinema_rechargeAppPromptTitle: "Tải ứng dụng để nhận xu thưởng",
  cinema_rechargeAppPromptReward: "Tải xuống và đăng nhập để nhận thêm {{points}} xu!",
  cinema_rechargeAppPromptDesc: "Tận hưởng trải nghiệm phát lại ổn định hơn và tự động lưu tiến trình xem trên ứng dụng.",
  cinema_appDownloadQr: "Quét để tải ứng dụng",
  cinema_ageGateBadge: "Xác minh độ tuổi",
  cinema_ageGateTitle: "Thông báo nội dung dành cho người trưởng thành",
  cinema_ageGateDescription: "Trang web này chứa nội dung giả tưởng do AI tạo ra, chỉ dành cho người trưởng thành. Bằng cách tiếp tục, bạn xác nhận rằng mình ít nhất 18 tuổi và đồng ý tuân thủ pháp luật tại nơi cư trú.",
  cinema_ageGateUnderage: "Nếu bạn dưới 18 tuổi, vui lòng rời khỏi trang web này ngay lập tức.",
  cinema_ageGateConfirm: "Tôi từ 18 tuổi trở lên — truy cập trang web",
  cinema_creatorCenter: "Trung tâm sáng tạo",
  cinema_creatorCenterDesc: "Tạo nên những câu chuyện của riêng bạn, chia sẻ thế giới của bạn",
  cinema_creatorCenterNote: "Lưu ý: Các tác phẩm không phải bản gốc phải không có dấu mờ nước",
  cinema_creatorMemberReady: "Bạn là thành viên VIP, nộp đơn chỉ với một cú nhấp chuột",
  cinema_creatorBecome: "Trở thành Nhà sáng tạo",
  cinema_creatorGateDesc: "Mang những câu chuyện của bạn đến với Huangguo TV. Sau khi được phê duyệt, tác phẩm của bạn sẽ được phát sóng trên nền tảng điện ảnh, thu hút hàng triệu khán giả chiêm ngưỡng tài năng và hưởng phần trăm doanh thu từ gói thuê bao cao cấp.",
  cinema_creatorApplyBtn: "Nộp đơn trở thành Nhà sáng tạo",
  cinema_creatorBenefitTitle: "Quyền lợi dành cho Nhà sáng tạo",
  cinema_creatorBenefit1: "Được gắn thẻ “Bản gốc” riêng biệt cho tác phẩm của mình",
  cinema_creatorBenefit2: "Theo dõi lượt xem, số lượng thuê bao và phần trăm doanh thu theo thời gian thực",
  cinema_creatorBenefit3: "Mở khóa thêm nhiều công cụ sáng tạo và nguồn lực quảng bá",
  cinema_creatorReviewTip: "Hồ sơ và tác phẩm đều được nền tảng kiểm duyệt và phải tuân thủ hướng dẫn cộng đồng.",
  cinema_creatorLevel: "Nhà sáng tạo đã được xác minh",
  cinema_creatorOriginal: "Bản gốc",
  cinema_creatorSince: "Nhà sáng tạo từ",
  cinema_creatorAddWork: "Tải lên tác phẩm mới",
  cinema_creatorTabOverview: "Tổng quan",
  cinema_creatorTabWorks: "Tác phẩm của tôi",
  cinema_creatorTabUpload: "Tải lên",
  cinema_creatorTabPlatform: "Studio",
  cinema_creatorSubmitted: "Đã gửi, đang chờ xét duyệt",
  cinema_creatorStatViews: "Tổng lượt xem",
  cinema_creatorStatSubs: "Tổng số người đăng ký",
  cinema_creatorStatRevenue: "Tổng doanh thu",
  cinema_creatorStatWithdraw: "Có thể rút",
  cinema_creatorStatWorks: "Tác phẩm",
  cinema_creatorStatReview: "Đang xét duyệt",
  cinema_creatorStatRejected: "Bị từ chối",
  cinema_creatorTopWork: "Tác phẩm hiệu suất tốt nhất",
  cinema_creatorViews: "Lượt xem",
  cinema_creatorSubscriptions: "Người đăng ký",
  cinema_creatorShare: "Doanh thu",
  cinema_creatorNoPublished: "Chưa có tác phẩm nào được đăng tải",
  cinema_creatorFilterPublished: "Đã đăng tải",
  cinema_creatorFilterReview: "Đang xét duyệt",
  cinema_creatorFilterRejected: "Bị từ chối",
  cinema_creatorWorksTitle: "Tác phẩm của tôi",
  cinema_creatorNoWorks: "Chưa có tác phẩm nào, hãy tải lên tác phẩm đầu tiên của bạn",
  cinema_creatorGoUpload: "Tải lên ngay",
  cinema_creatorStatusPublished: "Đã đăng tải",
  cinema_creatorStatusReview: "Đang xét duyệt",
  cinema_creatorStatusApproved: "Đang chờ chuyển mã",
  cinema_creatorStatusTranscoding: "Đang chuyển mã",
  cinema_creatorStatusReady: "Đang chờ đăng tải",
  cinema_creatorStatusTranscodeFailed: "Chuyển mã thất bại",
  cinema_creatorStatusPublishFailed: "Đăng tải thất bại",
  cinema_creatorStatusRejected: "Bị từ chối",
  cinema_creatorPublishedOn: "Được đăng tải vào",
  cinema_creatorSubmittedOn: "Được gửi vào",
  cinema_creatorRejectedTip: "Bị từ chối · Được gửi vào",
  cinema_creatorWorkName: "Tiêu đề tác phẩm",
  cinema_creatorWorkNamePh: "Nhập tiêu đề tác phẩm",
  cinema_creatorCategory: "Thể loại",
  cinema_creatorCover: "Ảnh bìa",
  cinema_creatorCoverHint: "Tải lên một ảnh bìa dạng chân dung",
  cinema_creatorCoverUrlPh: "Dán liên kết hình ảnh (tùy chọn)",
  cinema_creatorSynopsis: "Tóm tắt nội dung",
  cinema_creatorSynopsisPh: "Hãy mô tả câu chuyện của bạn trong một hoặc hai câu…",
  cinema_creatorEpisodeTitle: "Các tập",
  cinema_creatorEpisodeDesc: "Thêm tiêu đề và tải lên một video MP4 hoặc MOV cho mỗi tập",
  cinema_creatorEpisodeTitlePh: "Tiêu đề tập",
  cinema_creatorEpisodeDurPh: "Thời lượng (phút)",
  cinema_creatorAddEpisode: "Thêm tập",
  cinema_creatorEpShort: "Tập {{count}}",
  cinema_creatorEpisodeUpload: "Tải video lên",
  cinema_creatorEpisodeUploading: "Đang tải lên…",
  cinema_creatorEpisodeReplace: "Thay thế video",
  cinema_creatorEpisodeMp4Only: "Hỗ trợ file .mp4 và .mov, tối đa 100 MB mỗi file",
  cinema_creatorEpisodeTypeError: "Mỗi tập phải là video .mp4 hoặc .mov",
  cinema_creatorEpisodeSizeError: "Video của mỗi tập không được lớn hơn 100 MB",
  cinema_creatorEpisodeUploadFailed: "Tải lên tập thất bại. Vui lòng thử lại.",
  cinema_creatorEpisodeRequired: "Thêm tiêu đề và tải lên một video MP4 hoặc MOV cho mỗi tập",
  cinema_creatorRequired: "Vui lòng điền tiêu đề và chọn ảnh bìa trước",
  cinema_creatorWorkNameRequired: "Nhập tiêu đề tác phẩm",
  cinema_creatorCategoryRequired: "Chọn danh mục",
  cinema_creatorCoverRequired: "Tải lên ảnh bìa",
  cinema_creatorEpisodeTitleRequired: "Nhập tiêu đề tập",
  cinema_creatorEpisodeVideoRequired: "Tải lên video MP4 hoặc MOV cho tập này",
  cinema_creatorSubmit: "Gửi để xem xét",
  cinema_creatorPlatformTag: "Được đề xuất bởi người sáng tạo",
  cinema_creatorPlatformTitle: "Nền tảng công cụ sáng tạo",
  cinema_creatorPlatformDesc: "Hãy đến với nền tảng sáng tạo chính thức để có các công cụ chuyên nghiệp, nguồn cảm hứng kịch bản và tài nguyên, giúp hiện thực hóa câu chuyện của bạn và đăng tải nó.",
  cinema_creatorPlatformPoint1: "Kịch bản & ý tưởng AI",
  cinema_creatorPlatformPoint2: "Công cụ sáng tạo & tải lên chuyên nghiệp",
  cinema_creatorPlatformPoint3: "Hỗ trợ lưu lượng truy cập & thanh toán",
  cinema_creatorPlatformOpen: "Đến nền tảng sáng tạo",
  cinema_creatorEarnBannerTitle: "Đưa câu chuyện của bạn lên màn bạc",
  cinema_creatorEarnBannerDesc: "Trở thành nhà sáng tạo, đăng tải tác phẩm và kiếm tiền từ lượt xem, lượt đăng ký cũng như chia sẻ doanh thu",
  cinema_creatorEarnBannerBtn: "Mở Trung tâm Nhà sáng tạo",
  cinema_creatorApplyFailed: "Đăng ký thất bại. Vui lòng thử lại.",
  cinema_creatorSubmitFailed: "Gửi thất bại. Vui lòng thử lại.",
  cinema_creatorSubmitting: "Đang gửi…",
  cinema_creatorCategoryEmpty: "Không có danh mục nào available",
  cinema_creatorCoverUpload: "Tải lên ảnh bìa",
  cinema_creatorCoverUploading: "Đang tải lên…",
  cinema_creatorCoverChoose: "Chọn ảnh",
  cinema_creatorCoverReplace: "Thay thế ảnh",
  cinema_creatorCoverRemove: "Xóa",
  cinema_creatorCoverFormat: "JPG, PNG, WebP hoặc GIF, tối đa 10 MB. Chỉ được tải lên một hình ảnh.",
  cinema_creatorCoverTypeError: "Chọn một hình ảnh JPG, PNG, WebP hoặc GIF",
  cinema_creatorCoverSizeError: "Hình ảnh bìa không được lớn hơn 10 MB",
  cinema_creatorCoverUploadFailed: "Tải lên hình ảnh bìa thất bại. Vui lòng thử lại.",
  cinema_creatorUploadNoticeTitle: "Hướng dẫn tải lên",
  cinema_creatorUploadNotice1: "Tất cả các tài nguyên được tải lên, dù là bản gốc hay bản sao, đều phải không có dấu mờ.",
  cinema_creatorUploadNotice2: "Các nhà sáng tạo bản gốc có thể liên hệ với đội ngũ kinh doanh của chúng tôi để đăng ký quyền sở hữu bản quyền.",
  cinema_creatorUploadNotice3: "Giá cho tập cuối cùng được xác định bởi nền tảng.",
  cinema_creatorUploadNotice4: "Mỗi tập phim phải dài ít nhất 150 giây.",
  cinema_creatorUploadNoticeConfirm: "Tôi đã hiểu, tiếp tục",
  cinema_navProfile: "Của tôi",
};
